import {
  HttpInterceptor,
  HttpHandler,
  HttpEvent,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { MsalService } from '@azure/msal-angular';
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { PortalService } from "../../services/portal.service";

@Injectable()
export class authHttpInterceptor implements HttpInterceptor {
  constructor(private portalService:PortalService, private msalService: MsalService, private activatedRoute:ActivatedRoute, private router:Router) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const jwt = localStorage.getItem("token");
    if (!!jwt) {
      req = req.clone({
        setHeaders: {
          'Authorization': "Bearer " + jwt,
          'ProgramID': environment.programID,
          'ManufacturerID': environment.manufacturerID,
          'api-version': environment.apiVersion,
          'Ocp-Apim-Subscription-Key':environment.OcpApimKey
        },
      });
    }else {
      console.error('No JWT token found - Redirecting to B2C login');
      this.msalService.loginRedirect(); 
      return throwError(() => new Error('No JWT token found - Redirecting to B2C login'));
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.router.navigate(['/home'], { relativeTo: this.activatedRoute })
          this.msalService.logoutRedirect();
        } 
        return throwError(() => error);
      })
    );
  }
}
